import {HotelsDblockInput} from './types';
import Megatron from '@stencil/megatron';
import {noOfNights} from '@stencil/hotels-utils/src/common-utils';
import roomStringUtils from '@stencil/hotels-utils/src/room-string-utils';

import dateFormat from 'dateformat';
import querystring from 'query-string';
import {appConfig} from '@stencil/hotels-config';

export function prepareDescblockUrl(flavour?: string) {
  let flavourQuery = (!!flavour && `&flavour=${flavour}`) || '';
  return `/hotels/personalized-getHotelDescBlock/?per=1&format=v2${flavourQuery}`;
}

const hotelsDescblockApi = async ({checkin, checkout, input, flavour = ''}: HotelsDblockInput) => {
  const {
    hc,
    strQry,
    v,
    rtc,
    rpc,
    fwdParams,
    code,
    pay_mode,
    gds,
    // vcid,
    rtn,
    // rwt,
    ext = false,
    gseg,
    cot,
    paxString,
    hmd,
    gsv = '',
    pah = '',
  }: any = input;

  const hardcoded = {
    user_latitude: '',
    user_longitude: '',
    vo: '',
    rpco: '',
    gohtlid: '',
    checkin_display: '',
    rtco: '',
    HotelAddress: '',
    destination: '',
    HotelRating: [],
    vertical: 'hotels',
    Image: '',
    checkout_display: '',
    newui: 'True',
    country: '',
    country_code: '',
    HotelName: '',
    city: '',
  };

  const ci = dateFormat(checkin, 'yyyymmdd');
  const co = dateFormat(checkout, 'yyyymmdd');

  // const [roomCount, paxCount, childCount] = roomStringUtils.splitRoomString(roomString);

  const {childrenCount, adultCount, roomConfig} = roomStringUtils.getRoomConfig(paxString);

  const strQuery = strQry ? strQry.split('-') : [];
  const vcid = strQuery[1] || '';

  const qd = {
    rtc,
    hc,
    rpc,
    code: code || 'qwerty',
    noOfNights: noOfNights(checkout, checkin),
    rooms: roomConfig.map(item => ({adults: item.adult, childs: item.childArray || []})),
    voyagerid: vcid,
    noofAdults: adultCount,
    pax: paxString,
    chkindate: ci,
    chkoutdate: co,
    checkin: ci,
    checkout: co,
    noofChildren: childrenCount,
    strQry,
    fwdParams,
    noofRooms: roomConfig.length,
    v,
    reprice_new: 1,
    pay_mode,
    // rec_why: rwt ? 1 : 0,
    rtn,
    ext,
    gseg,
    cot,
    hmd,
    gsv,
    pah,
  };

  const querydata = {
    ...hardcoded,
    ...qd,
    url_nhotels: appConfig.descblockNewHotelsId,
  };
  const data = {
    code: querydata.code !== undefined ? querydata.code.toUpperCase() : '',
    version: 'v2',
    querydata: JSON.stringify(querydata),
  };

  // const __goibibo__ = 'https://www.goibibo.com'; // have to be shifted to config package
  const __descblock__ = prepareDescblockUrl(flavour); // have to be shifted to config package
  const url = `${__descblock__}`;

  const response = await Megatron({
    name: 'desc block api',
    type: 'POST',
    url,
    requestData: querystring.stringify(data),
    credentials: 'include',
    headers: {'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'},
  });
  return response;
};

export default hotelsDescblockApi;
